/**
 * Returns responses that match the given prompt, classroom, and article id
 * @param {array} responses
 * @param {boolean} isCompleted
 * @returns {array}
 */
const getWritePromptResponsesByCompletionStatus = (
  responses,
  isCompleted = false,
) => {
  if (!responses) return [];

  const filteredResponses = responses.filter((response) => {
    return isCompleted
      ? response.date_completed !== null
      : response.date_completed === null;
  });

  return filteredResponses;
};

export default getWritePromptResponsesByCompletionStatus;
